import { createSelector } from 'reselect'

function invitesRootSelector(state) {
  return state.invites
}

export const getInvitesList = createSelector(invitesRootSelector, invites =>
  invites.get('list').toJS()
)

export const getInvitesResend = createSelector(invitesRootSelector, invites =>
  invites.get('resend').toJS()
)

export const getInvitesDelete = createSelector(invitesRootSelector, invites =>
  invites.get('delete').toJS()
)
